module.exports = __webpack_public_path__ + "img/oth12.06c352e5.png";